<div class="container clickable" [ngClass]="{'disabled': disabled, 'hidden': hidden, 'aligned-left': isAlignedLeft, 'normal-weight': normalFontWeight}" (click)="showList()">
    <div class="sopo-selected" *ngIf="list">{{ selectedText !== '' ? selectedText : selected }}</div>
    <div class="sopo-selected" *ngIf="selectedObjectText !== ''">{{ selectedObjectText }}</div>
    <ion-icon 
        class="caret" 
        name="caret-down-outline"
        *ngIf="showIcon">
    </ion-icon>
</div>